import React, { useState, useEffect, useContext } from "react";
import salesRepData from "../data/salesRepData.json";
import QueryStringContext from "./QueryStringContext";
import "../App.css";


const SalesRepInfo_PreFilled = () => {
  const { agent} = useContext(QueryStringContext);
  const [salesRep, setSalesRep] = useState(null);


  useEffect(() => {
    try {
      const selectedSalesRep = salesRepData.find(
        (rep) => rep.id === parseInt(agent)
      );
      if (selectedSalesRep) {
        setSalesRep(selectedSalesRep);
      } else {
        throw new Error("SalesRep not found");
      }
    } catch (error) {
      console.error("Error finding salesRep:", error);
      const selectedSalesRep = salesRepData.find((rep) => rep.id === 1);
      setSalesRep(selectedSalesRep);
    }
  }, [agent]);
  


  if (!salesRep) {
    return <div>Loading...</div>;
  }

  return (
    <>
    <div className='center'style={{maxWidth:'80vw'}}>
    <div className='featured' style={{backgroundColor:'transparent', border:'0', maxWidth:'80vw', padding:'0rem'}}>
    
    <div className='row' style={{flexDirection:'column'}}>
    <div className='column center' >
      <div className='testimonial-image-wrapper' style={{borderWidth:".2rem"}}>{salesRep.photo && (
        <img className='testimonial-image' src={salesRep.photo} alt={salesRep.name} />
      )}
      </div>
      </div>
      <div className='column center'>
      <div className='inputResultsFinal center' style={{ color:'white', fontSize:'1rem', marginBottom:'1rem'}}>
      <div style={{ color:'#BCD400', fontSize:'1.5rem' }}>{salesRep.name}</div>
      <div style={{ color:'#333', fontWeight:'700'}}>{salesRep.email}</div>
      <div style={{ color:'#333', fontWeight:'700'}}>{salesRep.phone}</div>
      </div>
      
      </div>
      
    </div>
    </div>
    </div>
    </>
  );
};

export default SalesRepInfo_PreFilled;
